import React, { PureComponent } from 'react';
import ConfettiBurstAnimation from '../animations/ConfettiBurstAnimation';
import FireAnimation from '../animations/FireAnimation';
import LightningAnimation from '../animations/LightningAnimation';
import LevelUpAnimation from '../animations/LevelUpAnimation';
import CleanCheckAnimation from '../animations/CleanCheckAnimation';
import FireworksAnimation from '../animations/FireworksAnimation';
import AuroraAnimation from '../animations/AuroraAnimation';
import ShockwaveAnimation from '../animations/ShockwaveAnimation';

const animationComponents = {
    finish_confetti: ConfettiBurstAnimation,
    finish_fire: FireAnimation,
    finish_lightning: LightningAnimation,
    finish_level_up: LevelUpAnimation,
    finish_clean_check: CleanCheckAnimation,
    finish_fireworks: FireworksAnimation,
    finish_aurora: AuroraAnimation,
    finish_shockwave: ShockwaveAnimation,
};

class FinishAnimationOverlay extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { visible: true };
    }

    componentDidMount() {
        this.timeout = setTimeout(() => {
            this.setState({ visible: false });
        }, 3000);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    render() {
        if (!this.state.visible) return null;

        const { animationId } = this.props;
        const AnimationComponent = animationComponents[animationId];

        if (!AnimationComponent) return null;

        return <AnimationComponent />;
    }
}

export default FinishAnimationOverlay;
